import React from "react";
import classes from "./Growth.module.css";
const Growth = () => {
  return (
    <div className={classes["growth-box"]}>
      <ul className={classes["growth-list"]}>
        <li
          className={`${classes["growth-list-item"]} ${classes["growth-list-item01"]} `}
        >
          <h4>프론트엔드 개발</h4>
          <ul>
            <li>React.js</li>
            <li>Next.js</li>
          </ul>
        </li>

        <li
          className={`${classes["growth-list-item"]} ${classes["growth-list-item02"]} `}
        >
          <h4>웹 기본</h4>
          <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>JAVASCRIPT</li>
          </ul>
        </li>
        <li
          className={`${classes["growth-list-item"]} ${classes["growth-list-item03"]} `}
        >
          <h4>백엔드 개발</h4>
          <ul>
            <li>JAVA</li>
            <li>SPRING</li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default Growth;
